import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'gatsby';

const defaultColor = '#333';
const size = 52;
const sizeSmall = 48;

const media = {
  handheld: (...args) => css`
    @media (max-width: 767px) {
      ${css(...args)};
    }
  `,
};

const mixin = css`
  display: inline-block;
  padding: 0 ${size}px;
  font-size: 18px;
  height: ${size}px;
  line-height: ${size - 4}px;
  color: ${props => props.color || defaultColor};
  font-weight: 600;
  background: ${props => props.fill || `transparent`};
  border: 2px solid ${props => props.fill || props.color || defaultColor};
  border-radius: ${size / 2}px;
  text-decoration: none;
  text-transform: uppercase;
  cursor: pointer;

  ${media.handheld`
    padding: 0 ${sizeSmall}px;
    font-size: 16px;
    height: ${sizeSmall}px;
    line-height: ${sizeSmall - 4}px;
    border-radius: ${sizeSmall / 2}px;
  `};
`;

const Button = styled.button`
  ${mixin};
`;

const ButtonAnchor = styled.a`
  ${mixin};
`;

const ButtonLink = styled(Link)`
  ${mixin};
`;

/* eslint-disable react/prop-types */
export default ({ link, external, children, ...props }) =>
  link ? (
    external ? (
      <ButtonAnchor href={props.to} {...props}>
        {children}
      </ButtonAnchor>
    ) : (
      <ButtonLink {...props}>{children}</ButtonLink>
    )
  ) : (
    <Button {...props}>{children}</Button>
  );
